import type { CalendarConversationInviteeType } from '@axiom/validation';

export const InterviewAttendeesAndLinkModalUtil = {
  checkDomainMismatch(
    contactEmails: Array<string | null>,
    adhocEmails: string[]
  ) {
    const contactDomains = new Set(
      contactEmails
        .filter((e): e is string => !!e)
        .map(e => e.split('@')[1]?.toLowerCase())
        .filter(Boolean)
    );

    if (contactDomains.size === 0) {
      return false;
    }

    return adhocEmails.some(email => {
      const domain = email.split('@')[1]?.toLowerCase();
      return domain && !contactDomains.has(domain);
    });
  },

  computeAttendeeDiff(
    currentInvitees: CalendarConversationInviteeType[],
    formContactIds: string[],
    formAdhocs: Array<{ firstName: string; lastName: string; email: string }>
  ) {
    const currentContactIds = new Set(
      currentInvitees
        .filter(i => i.contact)
        .map(i => i.contact?.id)
        .filter((id): id is string => !!id)
    );
    const currentAdhocEmails = new Set(
      currentInvitees
        .filter(i => i.adhocAttendee)
        .map(i => i.adhocAttendee?.email?.toLowerCase())
        .filter((e): e is string => !!e)
    );

    const newContactIds = formContactIds.filter(
      id => !currentContactIds.has(id)
    );
    const newAdhocs = formAdhocs.filter(
      a => !currentAdhocEmails.has(a.email.toLowerCase())
    );

    const formContactIdSet = new Set(formContactIds);
    const formAdhocEmailSet = new Set(
      formAdhocs.map(a => a.email.toLowerCase())
    );

    const toRemove = currentInvitees
      .filter(i => {
        if (i.candidate) return false;
        if (i.contact && !formContactIdSet.has(i.contact.id)) return true;
        if (
          i.adhocAttendee &&
          !formAdhocEmailSet.has(i.adhocAttendee.email?.toLowerCase() ?? '')
        )
          return true;
        return false;
      })
      .map(i => i.id);

    return {
      toAdd: {
        contactIds: newContactIds,
        adhocAttendees: newAdhocs,
      },
      toRemove,
    };
  },
};
